<script lang="ts" setup>
import type { SrcSetSizes } from '~/composables/useSrcSet'

export interface ArticleBoxFeaturedProps {
    data: BlogPost
    linkType: BlogPostType
}

const props = defineProps<ArticleBoxFeaturedProps>()
const imageSrc = computed((): SrcSetSizes | undefined =>
    useSrcSetSizes(props.data?.featured_images.path)
)
</script>
<template>
  <article
    class="row align-items-lg-center position-relative"
    data-cy="article_featured"
  >
    <Tracker
      :data="{
        position: 'Featured Article',
        title: props.data.category?.title,
      }"
    >
      <!-- Image column first in DOM to match visual order (WCAG 1.3.2) -->
      <div
        v-if="imageSrc"
        class="col-12 col-md-6 col-lg-8 mb-4 mb-md-0"
      >
        <img
          :srcset="imageSrc.srcSet"
          sizes="(min-width: 768px) 50vw, (min-width: 1230px) 77rem, 100vw"
          alt=""
          width="770"
          height="490"
          class="d-block img-fluid w-100 rounded"
        >
      </div>
      <!-- Content column second in DOM to match visual order -->
      <div class="col-12 col-md-6 col-lg-4">
        <div
          class="d-flex align-items-center justify-content-between mb-2"
        >
          <Label
            v-if="props.data.category?.title"
            :label="props.data.category.title"
            background-color="var(--global-color-secondary)"
            text-color="var(--global-color-white)"
            class="d-inline-flex"
          />
          <ArticleDate
            v-if="props.data.published_at"
            :date="props.data.published_at"
          />
        </div>
        <Heading
          level="h2"
          class="gamma mb-3"
        >
          <VNuxtLink
            :to="
              useBlogPostNamedRoute({
                slug: props.data.slug,
                type: props.linkType,
              })
            "
            :label="props.data.title"
            class="text-black stretched-link text-decoration-underline"
          >
            {{ props.data.title }}
          </VNuxtLink>
        </Heading>
        <Typo>
          <p class="fs-big fs-md-biggest mb-0">
            {{ props.data.perex }}
          </p>
        </Typo>
      </div>
    </Tracker>
  </article>
</template>
